export { pickUpDetailColumns } from './pickUpDetailColumns';
export { pickUpTableColumns } from './pickUpTableColumns';

export const PICKUP_STATUS_LABELS: Record<string, string> = {
  PENDING: 'Pendiente',
  COMPLETED: 'Completado',
  FAILED: 'Fallido',
  CANCELLED: 'Cancelado',
  PICKED_UP: 'Retirado',
};

export const PICKUP_STATUS_CLASSES: Record<string, string> = {
  PENDING: 'bg-amber-100 text-amber-800 border border-amber-200',
  COMPLETED: 'bg-emerald-100 text-emerald-800 border border-emerald-200',
  FAILED: 'bg-rose-100 text-rose-800 border border-rose-200',
  CANCELLED: 'bg-slate-100 text-slate-800 border border-slate-200',
};

export const DEFAULT_STATUS_CLASS = 'bg-slate-100 text-slate-800 border border-slate-200';

export const STATUS_BADGE_CONFIG: Record<string, { backgroundColor: string; ballColor: string; textColor: string }> = {
  PENDING:   { backgroundColor: '#FFF8E1', ballColor: '#F9A825', textColor: '#B78103' },
  COMPLETED: { backgroundColor: '#E8F5E9', ballColor: '#2E7D32', textColor: '#2E7D32' },
  FAILED:    { backgroundColor: '#FFEBEE', ballColor: '#C62828', textColor: '#C62828' },
  CANCELLED: { backgroundColor: '#ECEFF1', ballColor: '#546E7A', textColor: '#546E7A' },
  PICKED_UP: { backgroundColor: '#E8F5E9', ballColor: '#2E7D32', textColor: '#2E7D32' },
};

export const DEFAULT_BADGE_CONFIG = { backgroundColor: '#ECEFF1', ballColor: '#546E7A', textColor: '#546E7A' };
